
import All from "./components/All";
import All_certificates from "./components/Products";
import Contact from "./components/Contact";

import { BrowserRouter as Router, Route, Switch, Routes, BrowserRouter } from 'react-router-dom';
// import Service from "./components/Service";
import { useEffect } from "react";
import Product from "./components/Product";
import Products from "./components/Products";

function App () {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<All />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/product/:keyword" element={<Product />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
